/**
 * ぐるなびネット予約連携しているのかを返します
 * @param {object} 店舗情報（store.current）
 * @returns {boolean}
 */
export function isGnaviSync({ syncStatus }) {
  return syncStatus.gnavi !== 0
}

/**
 * レスラク連携しているのかを返します
 * @param {object} 店舗情報（store.current）
 * @returns {boolean}
 */
export function isResrakuAlignment({ syncStatus }) {
  return syncStatus.resraku === 3
}
